export enum PublicDeveloperDetailsPreviewParams {
  previewUuid = "previewUuid",
}
